export default "__VITE_ASSET__CD6aPUBW__"